import { pagination } from 'instantsearch.js/es/widgets'

export function createPagination() {
  return pagination({
    container: '#pagination',
    scrollTo: '#main-content',
    showFirst: false,
    showLast: false,
    templates: {
      next: ' <svg class="transition fill-current w-3 h-3 transform -rotate-90"><use xlink:href="#angle-down"></use></svg>',
      previous: ' <svg class="transition fill-current w-3 h-3 transform rotate-90"><use xlink:href="#angle-down"></use></svg>',
    },
  })
}
